

const FLAVORS = [
    "apple",
    "blackberry",
    "blueberrypomegranate",
    "cherry",
    "coconutpineapple",
    "cranberry",
    "grapefruit",
    "justbubly",
    "lemon",
    "lime",
    "mango",
    "orange",
    "passionfruit",
    "peach",
    "pineapple",
    "raspberry",
    "strawberry",
    "strawberrysunset",
    "watermelon",
    "bellini bliss",
    "whitepeachginger",
    "blood orange grapefruit",
    "triple berry",
    "citrus cherry",
    "mango passion fruit",
    "peach mango bubly burst",
    "triple berry bubly burst",
    "tropical punch bubly burst",
    "watermelon lime bubly burst",
    "cherry lemonade bubly burst",
    "pineapple tangerine bubly burst",
]

const ALCOHOL = [
    "amaretto",
    "bitters",
    "bourbon",
    "champagne",
    "gin",
    "liqueur",
    "rum",
    "prosecco",
    "schnapps",
    "tequila",
    "triple sec",
    "vodka",
    "whiskey",
    "wine"
]


const mixologyData = {
    TITLE: "Bubly Mix & Mingle",
    CTA: "check out the recipe",
    FILTER_BY: "filter by",
    AGE_GATE: {
        TITLE: "oh hi",
        COPY: "please enter your date of birth.<br /> you must be 21 to see all the recipes."
    },
    FILTERS: [
        { name: "all" },
        { name: "cocktails" },
        { name: "mocktails" },
        { name: "flavor", sublist: FLAVORS },
        { name: "spirit", sublist: ALCOHOL },
        { name: "featured" }
    ],
    FOOTER: `PLEASE DRINK RESPONSIBLY. © ${(new Date().getFullYear() < 2024) ? 2024 : new Date().getFullYear()} BUBLY, the Bubly Designs and the Bubly Marks are trademarks.`
}
export default mixologyData


//////////////////
// WEBPACK FOOTER
// ./static/libs/mixology.js
// module id = fKJs
// module chunks = 0